import React, { useEffect, useState } from "react";
import "./SchittsCreekTitle.css";
import welcomelogo from "../assets/clients/headerpng.png";

const SchittsCreekTitle = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`title-container ${isVisible ? "" : "move-up"}`}>
      <h1 className="spalch1">
        <span className="word firstwordsplash">
          <img src={welcomelogo} alt="bhookr logo" id="welcomelogwidth"  loading="lazy" />
        </span>
      </h1>
    </div>
  );
};

export default SchittsCreekTitle;
